import * as t from 'io-ts';

import type { CheckBoxDefinition } from 'header/types';

import { define, createSpecSettingsInterface } from './_common';

export interface SingleSelectSettingDefinition extends CheckBoxDefinition {
    key: 'SINGLE_SELECT';
}

const definition: SingleSelectSettingDefinition = {
    key: 'SINGLE_SELECT',
    type: 'CheckBox',
    label: 'Single select',
    value: true,
    scope: 'designer',
};

const specSettingsInterface = createSpecSettingsInterface(definition, t.boolean);

export const codec = specSettingsInterface.input;

export const SingleSelectSettingDefinition = define({
    key: 'SINGLE_SELECT',
    label: 'singleSelect',
    definition,
    fromSetting: settings => specSettingsInterface.extractValue(settings.singleSelect),
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: settings =>
        specSettingsInterface.createDefinitionWithSettings(settings.singleSelect),
});
